// Backend references
export const BASE_URL = window.BASE_URL || process.env.BACKEND_URL;
export const API_BASE_URL = `${BASE_URL}/api`;
export const isVeevaMedcomms = (): boolean => window.VEEVA_DOMAIN === 'medcomms' || process.env.VEEVA_DOMAIN === 'medcomms';
